import React from "react";
import { Platform, StyleSheet } from "react-native";

var studyStyle = StyleSheet.create({
    //未见过
    notSee: {
        color: "#2f2f2f",
    },

    notSeeBg: {
        backgroundColor: "#F2F2F2"
    },

    //已见过
    viewed: {
        color: "#0058ff",
    },

    viewedBg: {
        backgroundColor:"#e7effe"
    },

    //已学习
    learned: {
        color: "#0058ff",
        //color: "#6fc8ff",
    },

    learnedBg: {
        backgroundColor:"#e7effe"
        //backgroundColor: "#EAF7FF",
    },

    //已练习
    practiced: {
        color: "#ffb007",
    },

    practicedBg: {
        backgroundColor: "#FFF4DD",
    },

    //已通过
    passed: {
        color: "#2cce48",
    },

    //单已通过背景色
    passedBg: {
        backgroundColor: "#e8ffe8"
    },
});

export default studyStyle;
